/**
 * Toast notification store using Svelte 5 Runes ($state).
 */

export interface ToastItem {
	id: string;
	type: 'info' | 'success' | 'warning' | 'error';
	message: string;
	duration?: number;
}

class ToastStore {
	toasts = $state<ToastItem[]>([]);

	add(type: ToastItem['type'], message: string, duration = 4000) {
		const id = crypto.randomUUID();
		const item: ToastItem = { id, type, message, duration };
		this.toasts.push(item);

		if (duration > 0) {
			setTimeout(() => {
				this.dismiss(id);
			}, duration);
		}
	}

	info(message: string, duration?: number) {
		this.add('info', message, duration);
	}

	success(message: string, duration?: number) {
		this.add('success', message, duration);
	}

	warning(message: string, duration?: number) {
		this.add('warning', message, duration);
	}

	error(message: string, duration?: number) {
		this.add('error', message, duration);
	}

	dismiss(id: string) {
		this.toasts = this.toasts.filter((t) => t.id !== id);
	}
}

export const toastStore = new ToastStore();
